/* eslint-disable sort-keys-fix/sort-keys-fix */
import { COMMUNITY_PAGES_PATH_PREFIX, type CommunityData } from "./types"

const damntechno: CommunityData = {
  code: "damntechno",
  inviteCode: "damntechno",
  name: "DAMnTechno",
  thumbnail: "",
  favicon: "",
  url: `${COMMUNITY_PAGES_PATH_PREFIX}/damntechno`,
  socials: {},
  styles: {
    global: {
      counterColor: "#FFFFFF",
      logo: {
        src: "/assets/customizations/damntechno/logo.png",
        styles: "w-[192px]",
      },
      alternativeLogo: {
        src: "/assets/customizations/damntechno/logo.png",
        styles: "w-[200px]",
      },
      modalWindow: {
        container: "",
        title: "",
        subtitle: "",
      },
      contentBoxShadow: "border-[2px] border-[#414141]",
      bgColor: "#000000",
      asideBg: "#000000",
      asideStyles: "",
      contentBg: "#000000",
      bgDesktop: "/assets/customizations/damntechno/bg.png",
      bgMobile: "/assets/customizations/damntechno/bg.png",
      mainFont: "font-['Barlow']",
      primaryButton:
        "border-[2px] border-[#414141] flex mt-2 !text-[#FFFFFF] uppercase justify-center items-center !text-[16px] leading-[18px] !h-[42px] bg-[#000000] !px-[16px] font-medium sm:!min-w-[154px] min-w-[160px] text-nowrap cursor-pointer",
    },
    navigation: {
      sideBarSeparator: "border-r-[1px] border-[#000000]",
      iconsColor: "#FFFFFF",
      separator: "border-t-[#414141] border-t border-opacity-50",
      item: "text-[16px] font-bold h-[40px] text-[#FFFFFF] uppercase flex sm:justify-start justify-center items-center sm:!pt-2 !pt-6",
      itemSelected: "custom-prefix",
    },
    communityLanding: {
      titles: "text-[28px] leading-[40px] font-bold text-[#FFFFFF] uppercase",
      announcements: {
        lg: {
          subtitle:
            "!text-[12px] font-semibold px-[6px] !bg-[#000000] !text-[#FFFFF] w-fit h-[26px] border-[2px] border-[#FFFFFF] flex items-center",
          title:
            "leading-[16px] font-bold !text-[#FFFFFF] !text-[12px] -mb-2 mt-[-4px] w-fit flex items-cente pt-1",
        },
        sm: {
          subtitle:
            "!text-[12px] font-semibold px-[6px] !bg-[#000000] !text-[#FFFFF] w-fit h-[26px] border-[2px] border-[#FFFFFF] flex items-center",
          title:
            "leading-[16px] mb-[2px] font-bold !text-[#FFFFFF] !text-[12px] -mb-2 mt-[-4px] w-fit flex items-cente pt-1",
        },
      },
      event: {
        title: "font-bold text-[16px] text-[#FFFFFF] one-line-truncate font-bold",
        subtitle: "text-[14px] text-[#FFFFFF] leading-[16px]",
      },
      shop: {
        title: "text-[16px] leading-[16px] text-[#FFFFFF] font-bold",
        text: "text-[14px] leading-[16px] text-[#FFFFFF] font-medium",
        customShopImage: "/assets/customizations/damntechno/shop.png",
      },
      emptyOrLoadingState: "text-[16px] font-bold !text-[#FFFFFF]",
    },
    events: {
      container: "mb-16 sm:p-11 p-7 sm:pb-8 sm:space-y-[57px] space-y-[25px]",
      header: "text-[28px] leading-[40px] font-bold text-[#FFFFFF] uppercase",
      sectionHeader: "font-bold text-[16px] text-[#FFFFFF] one-line-truncate font-bold",
      separator: "mb-8 mt-2 border-b border-b-[1px] border-[#414141]",
      title: "font-bold mt-1 text-[16px] text-[#FFFFFF] one-line-truncate font-bold",
      duration: "text-[12px] leading-[16px] text-[#FFFFFF] font-semibold",
      address: "text-[12px] leading-[16px] text-[#FFFFFF] font-semibold",
      emptyOrLoadingState: "!text-[#FFFFFF] font-bold text-[16px]",
    },
    event: {
      container: "flex flex-col sm:p-11 p-6",
      blockContainer: "flex flex-col gap-3",
      separator: "sm:my-8 my-6 border-b border-b-[1px] border-[#414141]",
      header:
        "text-[32px] font-bold text-[24px] leading-[24px] text-[#FFFFFF] !mt-0 sm:mb-0 mb-[24px]",
      sectionSubtitle: "text-[12px] leading-[12px] text-[#FFFFFF]",
      sectionTitle: "leading-[15px] text-[#FFFFFF] font-bold !text-[16px]",
      text: "text-[14px] text-[#FFFFFF] leading-[17px] text-medium",
      map: {
        border:
          "mb-2 border-[1px] flex justify-center border-[2px] border-[#414141] overflow-hidden",
        pin: "",
        pinColor: "#000000",
        strokeColor: "#000000",
      },
      emptyOrLoadingState: "font-bold text-[16px] text-[#FFFFFF]",
    },
    eventTickets: {
      container: "flex flex-col sm:p-11 p-6",
      event: {
        title: "!mt-0 font-bold text-[24px] leading-[24px] text-[#FFFFFF]",
        subtitle: "text-[12px] leading-[12px] text-[#FFFFFF]",
      },
      separator: "sm:my-8 my-6 border-b-[#414141] border-b-[1px]",
      ticket: {
        title: "text-[16px] font-bold text-[#FFFFFF]",
        description: "capitalize !text-[14px] text-[#FFFFFF] text-medium",
        text: "capitalize !font-normal !text-[14px] text-[#FFFFFF] text-medium",
        price: "text-[16px] font-bold text-[#FFFFFF]",
        counterContainer: "text-[12px] border-[2px] !border-[#414141]",
        quantity: "text-nowrap pt-1 text-[12px] text-[#FFFFFF] text-medium",
      },
    },
    announcements: {
      container: "mb-16 sm:p-11 p-7 sm:space-y-[38px] space-y-[33px]",
      header: "text-[28px] leading-[40px] font-bold text-[#FFFFFF] uppercase",
      created: "text-[12px] normal-case leading-[16px] text-[#FFFFFF] !font-semibold",
      title: "text-[24px] leading-[26px] text-[#FFFFFF] font-bold text-medium",
      description: "text-[14px] leading-[16px] text-[#FFFFFF] font-medium",
      emptyOrLoadingState: "font-bold text-[16px] text-[#FFFFFF]",
    },
    announcement: {
      container: "sm:p-10 p-7 pb-8 space-y-[23px]",
      created: "text-[12px] normal-case text-medium leading-[16px] text-[#FFFFFF] !font-semibold",
      title: "text-[24px] leading-[26px] text-[#FFFFFF] font-bold",
      description: "text-[14px] leading-[16px] text-[#FFFFFF] font-medium",
      likeIconColor: "#FFFFFF",
      likeCount: "text-[#FFFFFF]",
      commentIconColor: "#FFFFFF",
      commentCount: "text-[#FFFFFF]",
      emptyOrLoadingState: "font-bold text-[16px] text-[#FFFFFF]",
    },
    shop: {
      container: "mb-16 sm:p-11 p-7 sm:pb-8",
      sectionTitle: "font-bold text-[16px] text-[#FFFFFF] one-line-truncate font-bold",
      separator: "mt-2 sm:mb-7 mb-6 border-b border-b-[1px] border-[#414141]",
      header: "text-[28px] leading-[40px] font-bold text-[#FFFFFF] uppercase",
      emptyState: "font-bold text-[16px] text-[#FFFFFF]",
    },
    linktree: {
      container:
        "font-['Barlow'] flex flex-col items-center h-full w-full bg-cover min-h-screen relative bg-[#000000] p-[64px]",
      bgDesktop: "/assets/customizations/damntechno/bg.png",
      bgMobile: "/assets/customizations/damntechno/bg.png",
      communityInfo: {
        logo: "h-[128px] w-[128px] rounded-full",
        name: "text-[28px] uppercase font-bold text-[#FFFFFF] mt-2",
        location: "font-bold text-[#FFFFFF] text-[16px] leading-[16px] text-center mb-2",
        description: "font-medium text-[#FFFFFF] text-[14px] leading-[18px] text-center mb-4",
        socialMediaIconColor: "#FFFFFF",
        button:
          "text-[16px] font-medium flex mt-2 uppercase !text-[#FFFFFF] justify-center items-center !h-[50px] bg-[#000000] border-[#565656] border-[2px] !px-[20px] text-nowrap cursor-pointer",
      },
      upcomingEvents: {
        loadingState:
          "mb-[42px] text-[#FFFFFF] border-[2px] border-[#414141] !h-[56px] sm:w-[500px] w-[95vw] p-6 flex bg-[#000000] items-center text-[16px] font-bold",
        emptyState: {
          container:
            "border-[#414141] border-[2px] sm:w-[500px] w-[95vw] bg-[#000000] flex justify-between flex flex-col justify-center items-center p-[34px] mb-[32px]",
          title: "text-[16px] font-bold !text-[#FFFFFF]",
          text: "text-[14px] font-medium !text-[#FFFFFF]",
          button:
            "flex mt-7 !text-[#FFFFFF] font-medium justify-center items-center !text-[16px] !h-[42px] bg-[#000000] border-[#414141] border-[2px] !px-[24px] uppercase text-nowrap cursor-pointer w-fit",
        },
        header:
          "font-bold text-[28px] leading-[40px] uppercase !text-[#FFFFFF] mb-[10px] text-center w-screen",
        container: "gap-4 flex flex-col items-center",
        event: {
          container:
            "overflow-hidden border-[#414141] border-[2px] bg-[#000000] sm:w-[500px] w-[95vw]",
          name: "font-bold text-[20px] text-[#FFFFFF] leading-[20px] mb-1 sm:w-[390px] w-[65vw]",
          duration: "text-[14px] font-semibold leading-[24px] uppercase text-[#FFFFFF]",
          location: "text-[14px] font-semibold leading-[24px] text-[#FFFFFF] mt-[-8px]",
          startDate:
            "!w-[64px] text-[#FFFFFF] font-bold text-[28px] h-[64px] bg-[#BE0000] flex flex-col justify-center items-center gap-1",
          button:
            "flex mt-2 !text-[#FFFFFF] justify-center  font-medium items-center !text-[16px] !h-[42px] bg-[#000000] border-[#414141] border-[2px] !px-[24px] uppercase text-nowrap cursor-pointer w-fit",
          product: {
            container:
              "h-[74px] border-t border-t-[#565656] px-4 items-center flex justify-between",
            name: "text-[16px] font-bold text-[#FFFFFF] leading-[28px] mb-1 one-line-truncate sm:w-[390px] w-[65vw]",
            price: "text-[16px] font-bold leading-[22px] font-['FanwoodText'] text-[#FFFFFF]",
            status: "text-[15px] font-bold leading-[22px] text-[#FFFFFF]",
            link: "text-[14px] font-medium text-[#FFFFFF]",
            button:
              "flex mt-2 !text-[#FFFFFF] font-medium justify-center items-center !text-[16px] !h-[42px] bg-[#000000] border-[#414141] border-[2px] !px-[24px] uppercase text-nowrap cursor-pointer w-fit",
          },
        },
        collapsedEvent: {
          container:
            "h-[64px] border-[#414141] border-[2px] bg-[#000000] cursor-pointer sm:w-[500px] w-[95vw] flex justify-between pr-2",
          name: "text-[16px] font-bold text-[#FFFFFF] leading-[16px] pt-[2px] sm:w-[390px] w-[65vw] one-line-truncate",
          duration: "!text-[14px] mt-[-2px] font-semibold uppercase text-[#FFFFFF]",
          plusIconColor: "#FFFFFF",
          media: "overflow-hidden m-2 rounded-full",
        },
        seeAllEvents:
          "text-[14px] font-semibold text-[#FFFFFF] underline text-center mt-4 cursor-pointer mb-[32px]",
      },
      news: {
        container: "flex flex-col gap-4",
        loadingState:
          "mb-[42px] text-[#FFFFFF] border-[2px] border-[#414141] !h-[56px] sm:w-[500px] w-[95vw] p-6 flex bg-[#000000] items-center text-[16px] font-bold",
        header:
          "font-bold text-[28px] leading-[40px] uppercase !text-[#FFFFFF] mb-[10px] text-center w-screen",
        oneNews: {
          container:
            "pr-2 overflow-hidden border-[#414141] border-[2px] bg-[#000000] h-[80px] cursor-pointer sm:w-[500px] w-[95vw] flex justify-between",
          media: "rounded-full overflow-hidden w-[48px] h-[48px] ml-4 mr-2 mt-4",
          name: "text-[#FFFFFF] font-bold mt-[2px] !text-[16px] leading-[16px] mb-1 one-line-truncate sm:w-[390px] w-[65vw]",
          created: "text-[14px] font-semibold leading-[14px] mt-[-4px] text-[#FFFFFF]",
          triangleIconColor: "#FFFFFF",
        },
        seeAllNews:
          "text-[14px] font-semibold text-[#FFFFFF] underline text-center mt-4 cursor-pointer mb-[32px]",
      },
      otherLinks: {
        container: "flex flex-col gap-[10px] mb-[40px]",
        loadingState:
          "mb-[42px] text-[#FFFFFF] border-[2px] border-[#414141] !h-[56px] sm:w-[500px] w-[95vw] p-6 flex bg-[#000000] items-center text-[16px] font-bold",
        header:
          "font-bold text-[28px] leading-[40px] uppercase !text-[#FFFFFF] mb-[10px] text-center w-screen",
        link: {
          container:
            "h-[56px] border-[2px] border-[#414141] cursor-pointer p-2 sm:w-[500px] w-[95vw] flex justify-between bg-[#000000]",
          name: "ml-1 text-[16px] font-bold text-[#FFFFFF] leading-[16px] mb-[6px] mt-[4px] one-line-truncate sm:w-[390px] w-[65vw]",
          triangleIconColor: "#FFFFFF",
          circleIcon: "ml-2 w-[24px] h-[24px] rounded-full object-cover",
        },
      },
      footer: {
        WERZlogoColor: "#FFFFFF",
        text: "uppercase font-mono text-[11px] font-bold text-[#FFFFFF]",
      },
    },
  },
}

export default damntechno
